import axios from 'axios';
import { getEnvVariables } from 'utils/getEnvVariables';
import { store } from 'store';
import * as actionTypes from 'store/actions';

const { REACT_APP_MEDICAL_HEALTH_API_V1 } = getEnvVariables();

const MedicalHealthApi = axios.create({
    baseURL: REACT_APP_MEDICAL_HEALTH_API_V1
});
MedicalHealthApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Interceptor para manejar respuestas
MedicalHealthApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response?.status === 401 &&
            error.response?.data?.msg === 'Expiró el token de autenticación, por favor inicie sesión nuevamente'
        ) {
            // Limpiar localStorage y despachar acción de logout
            localStorage.clear();
            store.dispatch({ type: actionTypes.LOGOUT });
            console.warn('Sesión expirada');
        }
        return Promise.reject(error);
    }
);

export default MedicalHealthApi;
